import { useSearchParams } from '@remix-run/react'
import { Alert, Typography } from 'antd'
import React from 'react'

type Props = {
  errorKey?: string
}

export const ErrorMessage: React.FC<Props> = ({ errorKey: errorKeyForced }) => {
  const [searchParams] = useSearchParams()

  const errorKey = errorKeyForced ?? searchParams.get('error')

  const keyToMessage = {
    'bad-credentials': 'Email / password is incorrect',
    'bad-password-confirmation': 'Password confirmation is incorrect',
    'bad-password-current': 'Current password is incorrect',
    unknown: 'Something went wrong - Try again later',
    offline: 'Something went wrong - Try again later',
  }

  if (!errorKey) {
    return <></>
  }

  const errorMessage = keyToMessage[errorKey] ?? keyToMessage['offline']

  return (
    <>
      <Alert
        type="error"
        className="mt-4"
        style={{ textAlign: 'center' }}
        message={
          <Typography.Text type="danger">{errorMessage}</Typography.Text>
        }
      />
    </>
  )
}
